<template>
  <spinner v-if="isLoading"></spinner>
  <transition name="fade">
    <div>
      <BreadCrumbs
        :breadCrumbs="breadCrumbs"
        :title="title"
        :back_title="back_title"
        :link="link"
      />

      <div class="page">
        <div class="mb-2">
          <Button
            caption="Добавить"
            color="btn-green"
            add_class="w-100"
            @click="showForm"
          />
        </div>

        <div v-if="items.length">
          <div class="av_card" v-for="item in items" :key="item.id">
            <div class="mt-3 fw-normal">
              <div class="hstack d-flex justify-content-between item_title pb-2 mb-2">
                <div class="fs-4 fw-bold">
                  {{ item.code }} — {{ item.board_name }}
                </div>
                <div class="d-flex align-items-center">
                  <span class="badge me-3" :class="item.is_active ? 'bg-success' : 'bg-secondary'">
                    {{ item.is_active ? 'активен' : 'выкл.' }}
                  </span>
                  <div class="me-2">
                    <Button color="gray" btn_icon="edit" @click="editItem(item)" />
                  </div>
                  <div>
                    <Button color="btn-red" btn_icon="delete" @click="deleteItem(item.id)" />
                  </div>
                </div>
              </div>
              <div class="text-muted">
                <div><b>Модель:</b> {{ item.model }}</div>
                <div><b>Объём:</b> {{ item.volume || '—' }}</div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="text-center text-muted py-4">
          Справочник пуст. Добавьте запись.
        </div>

        <div class="mt-3">
          <Button
            color="gray"
            :caption="'Пересобрать кэш'"
            btn_icon="refresh"
            add_class="w-100"
            @click="rebuild"
          />
        </div>

        <transition name="slide-fade">
          <Modal v-if="isModalVisible" @close="closeModal">
            <template #body>
              <FormPrice
                :title="name_form"
                :id="current?.id || 0"
                :errors="errors"
                :item="current"
                @create-to="saveItem"
              />
            </template>
          </Modal>
        </transition>
      </div>
    </div>
  </transition>

  <transition name="slide-fade">
    <toast-alert
      v-if="is_alert"
      @close_alert="closeAlert"
      :message="message"
      :type="type"
    />
  </transition>
</template>

<script>
import * as api from "../../../services/carCodeMap"; // сервис с авторизацией через куки
import Spinner from "../../../components/Spinner.vue";
import BreadCrumbs from "../../../Page/BreadCrumbs.vue";
import Button from "../../../components/Button.vue";
import FormPrice from "./FormPrice.vue";
import Modal from "../../../components/Modal.vue";
import ToastAlert from "../../../components/ToastAlert.vue";

export default {
  name: "Price",
  components: { Spinner, BreadCrumbs, Button, FormPrice, Modal, ToastAlert },
  data() {
    return {
      message: "",
      type: "green",
      is_alert: false,
      isLoading: false,

      items: [],

      // форма
      isModalVisible: false,
      name_form: "",
      current: null, // {id, code, model, volume, board_name, is_active}
      errors: {},

      // хлебные крошки/заголовки
      breadCrumbs: true,
      title: "Справочник моделей",
      back_title: "Доска ТО",
      link: "boards/doska-to",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        // бэкенд отдаёт либо paginator, либо простой массив — поддержим оба варианта
        const resp = await api.index();
        this.items = Array.isArray(resp) ? resp : (resp.data || resp.items || []);
      } catch (e) {
        this.toast("Ошибка загрузки списка", "red");
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
    showForm() {
      this.name_form = "Добавить";
      this.current = { code: "", model: "", volume: "", board_name: "", is_active: true };
      this.errors = {};
      this.isModalVisible = true;
    },
    editItem(item) {
      this.name_form = "Редактировать";
      this.current = { ...item };
      this.errors = {};
      this.isModalVisible = true;
    },
    async saveItem(payload) {
      this.isLoading = true;
      try {
        if (payload.id && payload.id > 0) {
          await api.update(payload.id, payload);
          this.toast("Изменения сохранены", "green");
        } else {
          await api.store(payload);
          this.toast("Запись добавлена", "green");
        }
        this.closeModal();
        await this.getData();
      } catch (e) {
        if (e?.status === 422 || e?.data?.errors) {
          this.errors = e.data?.errors || {};
          this.toast("Проверьте поля формы", "red");
        } else {
          this.toast("Ошибка сохранения", "red");
        }
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
    async deleteItem(id) {
      if (!confirm("Удалить запись?")) return;
      this.isLoading = true;
      try {
        await api.destroy(id);
        this.toast("Удалено", "red");
        await this.getData();
      } catch (e) {
        this.toast("Ошибка удаления", "red");
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
    async rebuild() {
      this.isLoading = true;
      try {
        await api.rebuildCache();
        this.toast("Кэш пересобран", "green");
      } catch (e) {
        this.toast("Ошибка пересборки кэша", "red");
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
    closeModal() {
      this.isModalVisible = false;
      this.current = null;
      this.errors = {};
    },
    closeAlert() {
      this.is_alert = false;
    },
    toast(message, type = "green") {
      this.message = message;
      this.type = type;
      this.is_alert = true;
      setTimeout(() => this.closeAlert(), 3000);
    },
  },
};
</script>
